'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

const MissionVisionSection = () => {
  return (
    <section className="relative py-20 lg:py-32 overflow-hidden text-white" style={{ backgroundImage: 'linear-gradient(135deg, #06213f 0%, #0f3f87 34%, #2c78fb 68%, #3ee0be 100%)' }}>
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-96 h-96 bg-[#2c78fb]/20 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#3ee0be]/20 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 px-5 py-2.5 bg-white/14 backdrop-blur-md rounded-full mb-8 border border-white/20 shadow-lg">
            <Icon name="SparklesIcon" size={20} className="text-[#9ff9de]" />
            <span className="text-sm text-white font-semibold">Sobre LynMet</span>
          </div>

          <h1 className="text-4xl lg:text-6xl font-black text-white mb-6 leading-tight">
            Una Plataforma{' '}
            <span className="bg-clip-text text-transparent" style={{ backgroundImage: 'linear-gradient(135deg, #ffffff 0%, #b8fff0 45%, #7dd3fc 100%)' }}>
              Evolutiva
            </span>
            {' '}para tu Éxito
          </h1>

          <p className="text-xl lg:text-2xl text-white/95 leading-relaxed max-w-4xl mx-auto">
            LynMet es más que una herramienta: es tu compañero de viaje en el proceso de transformar ideas en negocios exitosos.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mt-16">
          {/* Mission */}
          <div className="app-glass-dark rounded-2xl p-8 hover:bg-white/18 transition-all duration-300">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ backgroundImage: 'linear-gradient(135deg, #3ee0be 0%, #2c78fb 100%)' }}>
                <Icon name="RocketLaunchIcon" size={24} className="text-white" />
              </div>
              <h2 className="text-2xl font-bold text-white">Nuestra Misión</h2>
            </div>
            <p className="text-white/90 leading-relaxed">
              Acompañar a emprendedores latinoamericanos en cada etapa de su viaje: desde la formación inicial de ideas, pasando por la consolidación de negocios, hasta la mejora continua y el crecimiento sostenible. Democratizamos el acceso a coaching empresarial de nivel mundial mediante inteligencia artificial.
            </p>
          </div>

          {/* Vision */}
          <div className="app-glass-dark rounded-2xl p-8 hover:bg-white/18 transition-all duration-300">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center" style={{ backgroundImage: 'linear-gradient(135deg, #2c78fb 0%, #8ee3ff 100%)' }}>
                <Icon name="EyeIcon" size={24} className="text-white" />
              </div>
              <h2 className="text-2xl font-bold text-white">Nuestra Visión</h2>
            </div>
            <p className="text-white/90 leading-relaxed">
              Convertirnos en el ecosistema de referencia para emprendedores en América Latina, conectando ideas innovadoras con inversionistas estratégicos. Aspiramos a crear una comunidad donde cada emprendedor tenga acceso a las herramientas, conocimientos y conexiones necesarias para alcanzar su máximo potencial.
            </p>
          </div>
        </div>

        {/* Key Values */}
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          <div className="bg-white/8 backdrop-blur-sm rounded-xl p-6 border border-white/10 text-center">
            <Icon name="AcademicCapIcon" size={32} className="text-[#9ff9de] mx-auto mb-3" />
            <h3 className="text-white font-bold mb-2">Educación Accesible</h3>
            <p className="text-white/80 text-sm">Coaching empresarial de calidad al alcance de todos</p>
          </div>
          <div className="bg-white/8 backdrop-blur-sm rounded-xl p-6 border border-white/10 text-center">
            <Icon name="ArrowPathIcon" size={32} className="text-sky-200 mx-auto mb-3" />
            <h3 className="text-white font-bold mb-2">Evolución Continua</h3>
            <p className="text-white/80 text-sm">Plataforma que crece y se adapta a tus necesidades</p>
          </div>
          <div className="bg-white/8 backdrop-blur-sm rounded-xl p-6 border border-white/10 text-center">
            <Icon name="HeartIcon" size={32} className="text-cyan-200 mx-auto mb-3" />
            <h3 className="text-white font-bold mb-2">Éxito del Emprendedor</h3>
            <p className="text-white/80 text-sm">Tu crecimiento es nuestra prioridad número uno</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVisionSection;
